let MIXIN = {
  data() {
      return {
          userMenu:[],
          managementMenu:[],
          // isSaved:true, // 判断除了【删除】以外的按钮 ， true => 显示，fales => 隐藏
          // isDeleted:true, // 判断 【删除】按钮 ， true => 显示，fales => 隐藏
      }
  },
  
  methods:{
    // 权限管理-判断是非为个体
    checkCompanys(path,isCheckShow,callback){
      path = this.$route.path;
      this.managementMenu = JSON.parse(sessionStorage.getItem('manageMenus'));
      if(this.managementMenu == null || this.managementMenu == '' || this.managementMenu == undefined || this.managementMenu.length <= 0){
        isCheckShow = false;
      } else {
        isCheckShow = true
      }
      return callback(isCheckShow)
    },

    // // 权限管理-判断页面是否有操作按钮
    // initCheckToShowBtn (path,isSaved,isDeleted,callback){
    //   path = this.$route.path;
    //   this.userMenu = JSON.parse(sessionStorage.getItem('userInfo')).menu;
    //   for (const i in this.userMenu) {
    //     var children = this.userMenu[i].children;
    //     for (const i2 in children) {
    //       var opBtnVO = children[i2].opBtnVO;
    //       if(path == children[i2].path){
    //         if(opBtnVO.availableSaved == false){
    //           isSaved = false;
    //         }else{
    //           isSaved = true;
    //         }
    //         if(opBtnVO.availableDeleted == false){
    //           isDeleted = false;
              
    //         }else{
    //           isDeleted = true;
    //         }
    //       }
    //     }
    //   }
      
    //   return callback(isSaved,isDeleted)
    // },


  },
};
export default MIXIN;